<template>
  <div am-image-params v-click-outside="() => {isEdit = false; isAdd = false}">
    <p class="_margin-right:1/4">Parameters</p>
      <div class="_display:flex _flex-wrap:wrap _align-items:center">
        <i-badge
          color="info"
          v-for="(value, key) in params"
          :key="key"
          am-param-badge
          class="_margin:1/4 _display:inline-flex _align-items:center _justify-content:space-between"
        >
          <p class="_margin:0">
            {{ Number(key) ?  `par ${key}` : `${key}`}} = {{ value }}
          </p>
          <div class="_margin-left:1/2">
            <svg viewBox="0 0 24 24" am-icon class="_margin-right:1/4" @click="editParam(key)" style="fill: var(--color--secondary-10);">
              <use xlink:href="@/assets/icons.svg#edit" x="0" y="0" width="24" height="24"></use>
            </svg>
            <svg viewBox="0 0 24 24" am-icon @click="delPar(key)" style="fill: var(--color--secondary-10);">
              <use xlink:href="@/assets/icons.svg#minus" x="0" y="0" width="24" height="24"></use>
            </svg>
          </div>
        </i-badge>
        <svg viewBox="0 0 24 24" class="_margin:1/4" am-icon @click="isAdd = true; isEdit = false">
          <use xlink:href="@/assets/icons.svg#plus" x="0" y="0" width="24" height="24"></use>
        </svg>
      </div>
      <template v-if="isEdit">
        <hr>
        <div am-edit-param class="_display:inline-flex _align-items:center">
          <p class="_margin-right:1/4">{{ Number(key) ? `par ${key} = ` : `${key} = ` }}</p>
          <i-input
            v-model.number="inputValue"
            placeholder="Value"
            am-number-input
            type="number"
          />
        </div>
        <hr>
      </template>
      <div v-if="isAdd" am-edit-param class="_display:inline-flex _align-items:center">
        <i-dropdown class="_margin-right:1/2">
          <div class="_display:flex _align-items:center">
            <p>{{ dropChecked }}</p>
            <i-icon name="ink-caret-down" />
          </div>
          <template #body>
            <i-dropdown-item
              v-for="dropValue in dropValues"
              :key="dropValue"
              :disabled="dropValue === dropChecked"
              @click.prevent="inputCheck(dropValue)"
            >
              {{ dropValue }}
            </i-dropdown-item>
          </template>
        </i-dropdown>
        <i-input
          v-if="dropChecked === 'par'"
          v-model.number="number"
          am-number-input
          type="number"
          placeholder="Number"
        />
        <p class="_margin-left:1/4 _margin-right:1/4">=</p>
        <i-input
          am-number-input
          v-model.number="value"
          type="number"
          placeholder="Value"
        />
      </div>
      <i-button
        v-if="isAdd"
        class="_width:50%"
        @click="add()"
      >
        Add
      </i-button>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'ImageParams',
  props: {
    image: {
      type: Object,
      required: true
    },
    data: {
      type: [Object, Boolean],
      default: false
    }
  },
  data: () => ({
    isEdit: false,
    key: null,
    isAdd: false,
    dropChecked: 'par',
    dropValues: ['par', 'завтал', 'waistband', 'ruffle', 'cuff', 'facing', 'loop', 'lining', 'elastik', 'rise'],
    number: null,
    value: null,
    oldParams: null
  }),
  computed: {
    ...mapState('parts', ['openImageModal']),
    params () {
      return this.image.params
    },
    inputValue: {
      get () {
        return this.params[this.key]
      },
      set (val) {
        this.SET_CHANGED_IMAGES({
          subtable: this.$route.params.subtable,
          data: this.image,
          field: 'params',
          oldParams: this.oldParams || {},
          partInfo: this.data || this.openImageModal.data
        })
        this.params[this.key] = val
      }
    }
  },
  mounted () {
    if (Object.keys(this.image.params).length !== 0) {
      this.oldParams = {}
      Object.assign(this.oldParams, this.image.params)
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_IMAGES']),
    async delPar (key) {
      await this.SET_CHANGED_IMAGES({
        subtable: this.$route.params.subtable,
        data: this.image,
        field: 'params',
        partInfo: this.data || this.openImageModal.data,
        oldParams: this.oldParams
      })
      delete this.params[key]
    },
    inputCheck (dropValue) {
      if (dropValue !== 'par') this.number = null
      this.dropChecked = dropValue
    },
    add () {
      if (this.dropChecked !== 'par' && this.value !== null) {
        this.params[this.dropChecked] = this.value
        this.dropChecked = 'par'
      } else if (this.value !== null && this.number) {
        this.params[this.number] = this.value
        this.number = null
      }
      this.isAdd = false
      this.SET_CHANGED_IMAGES({
        subtable: this.$route.params.subtable,
        data: this.image,
        field: 'params',
        partInfo: this.data || this.openImageModal.data
      })
      this.value = null
    },
    editParam (key) {
      this.key = key
      this.isEdit = true
      this.isAdd = false
    }
  }
}
</script>

<style lang="scss">
[am-image-params] {
  [am-number-input] {
    -moz-appearance: textfield;
    &::-webkit-inner-spin-button {
      display: none;
    }
  }
}
</style>
